import { InfoIcon } from '@phosphor-icons/react';
import { Popover, PopoverContent, PopoverTrigger } from '@voll-intelligence/ui-kit/ui/popover';
import { useId } from 'react';
import { SegmentedField } from '../../shared/field/segmented_field.js';

export interface GenderFieldCopy {
  readonly label: string;
  readonly female: string;
  readonly male: string;
  /** Por que o dado é pedido: o popover do «Por que?». */
  readonly note: string;
  /** O gatilho do popover ao lado do rótulo. */
  readonly why: string;
}

export interface GenderFieldProps {
  value?: 'F' | 'M';
  onChange: (v: 'F' | 'M') => void;
  copy: GenderFieldCopy;
}

/**
 * F/M sex picker that fits one grid column: the reason it is asked opens from «Por que?» next
 * to the label (a Popover, which opens on touch too) and also describes the radiogroup, so a
 * screen reader hears it without opening. The note is airline copy, so the field is meant for
 * flight: a product that adds it needs its own note. Requiredness is the host's rule.
 */
export function GenderField({ value, onChange, copy }: Readonly<GenderFieldProps>) {
  const noteId = useId();
  return (
    <div className="min-w-0">
      <SegmentedField
        label={copy.label}
        options={[
          { value: 'F', label: copy.female },
          { value: 'M', label: copy.male },
        ]}
        {...(value ? { value } : {})}
        onChange={onChange}
        describedBy={noteId}
        labelAside={
          <Popover>
            {/* Slot próprio: hosts sobem `[data-slot=popover-trigger]` (os selects) ao
                degrau de toque, e este é um link de texto ao lado do rótulo. */}
            <PopoverTrigger
              data-slot="gender-why"
              render={
                <button
                  type="button"
                  className="text-caption text-muted-foreground -my-1 inline-flex cursor-pointer items-center gap-1 py-1 underline decoration-border underline-offset-2"
                >
                  <InfoIcon size={14} aria-hidden />
                  {copy.why}
                </button>
              }
            />
            <PopoverContent align="start" className="text-caption w-72">
              {copy.note}
            </PopoverContent>
          </Popover>
        }
      />
      {/* `hidden`, não `sr-only`: o `aria-describedby` lê o texto mesmo oculto, e fora da
          árvore de acessibilidade ele não é lido de novo como texto solto depois do grupo. */}
      <span id={noteId} hidden>
        {copy.note}
      </span>
    </div>
  );
}
